import { useEffect, useState } from 'react';

export type BreakPoint = 'mobile' | 'tablet' | 'desktop';

interface BreakPointFlags {
	isMobile: boolean;
	isTablet: boolean;
	isDesktop: boolean;
	current: BreakPoint;
}

export function useBreakPoint() {
	const [breakpoint, setBreakPoint] = useState<BreakPointFlags>(() =>
		getBreakPointFlags(window.innerWidth)
	);

	useEffect(() => {
		const handleResize = () => {
			setBreakPoint(getBreakPointFlags(window.innerWidth));
		};

		window.addEventListener('resize', handleResize);
		handleResize(); // init
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return breakpoint;
}

// 👇 BreakPoints à adapter selon ton design system
function getBreakPointFlags(width: number): BreakPointFlags {
	if (width <= 768) {
		return {
			isMobile: true,
			isTablet: false,
			isDesktop: false,
			current: 'mobile',
		};
	} else if (width <= 1024) {
		return {
			isMobile: false,
			isTablet: true,
			isDesktop: false,
			current: 'tablet',
		};
	} else {
		return {
			isMobile: false,
			isTablet: false,
			isDesktop: true,
			current: 'desktop',
		};
	}
}
